function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "template-1");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 29.41,
  height: 4.37
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 38.34,
  y: 18.01,
  width: 8.58,
  height: 2.15
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 38.34,
  y: 21.4,
  width: 5.77,
  height: 2.15
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 38.34,
  y: 24.89,
  width: 8.58,
  height: 2.15
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 38.34,
  y: 28.27,
  width: 5.77,
  height: 2.15
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  y: 5.84,
  width: 49.59,
  height: 10.18
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  y: 46.97,
  width: 35.69,
  height: 7.83
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  y: 18.01,
  width: 35.69,
  height: 7.83
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  y: 27.67,
  width: 35.69,
  height: 7.83
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  y: 37.32,
  width: 35.69,
  height: 7.83
});

var SvgTemplate4 = function SvgTemplate4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Lager_1",
    "data-name": "Lager 1",
    viewBox: "0 0 49.59 54.8",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemplate4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/template-4.ce9ba9a1.svg";
export { ForwardRef as ReactComponent };